<template>
  <div class="p-6">
    <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Request</h3>
    <p class="text-[14px] text-grey-light-600 mt-1">Send cancellation request for this order</p>
    <hr class="my-4" />

    <OrderDetails
      :name="order?.name ?? ''"
      :reference="order?.reference ?? ''"
      :reason="lastNotification?.reason ?? ''"
    />

    <hr class="my-4" v-if="isDesktop" />

    <div class="mt-4 space-y-2">
      <div class="mb-4">
        <p class="text-grey-light-900 text-[12px]">New fee:</p>
        <p class="font-bold text-[30px] text-brand-600">{{ displayCurrency(cancellationFee) }}</p>
      </div>
      <div class="mb-4" v-if="merchantTermsDetail">
        <p class="text-grey-light-900 text-[12px]">Message:</p>
        <div class="p-2 border border-grey-light-200 rounded min-h-[30px] my-1">
          <p class="text-[12px] text-grey-light-600">
            {{ merchantTermsDetail }}
          </p>
        </div>
        <p class="text-[10px] text-grey-light-400 text-right">
          {{ formatDateMedium(parseOldNotificationDates(lastNotification?.date)) }} | {{ lastNotification?.name }}
        </p>
      </div>
    </div>

    <hr class="my-4" />

    <div class="flex gap-3">
      <Button class="flex-1 bg-teal-600 hover:bg-teal-700" :disabled="isSubmitting" @click="$emit('accept')">
        Accept
      </Button>
      <Button
        v-if="cancellationFee > 0"
        variant="outline"
        class="flex-1"
        :disabled="isSubmitting"
        @click="$emit('dispute')"
      >
        Dispute
      </Button>
      <Button
        variant="outline"
        class="flex-1 border-error-200 text-error-700 hover:text-error-700"
        :disabled="isSubmitting"
        @click="$emit('reject')"
      >
        Reject
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import OrderDetails from '@/components/shopper/lay-by/cancellation-request/OrderDetails.vue';
import { Button } from '@/components/ui/button';
import { displayCurrency, formatDateMedium, parseOldNotificationDates } from '@/utils/format.utils.js';
import { cleanDetails } from '@/utils/text.utils';
import { useBreakpoint } from '@/utils/useBreakPoint';
import { computed } from 'vue';
import type { ModelNote, ModelOrderResponse } from '@layup/api-sdk';

const { isDesktop } = useBreakpoint();

const props = defineProps<{
  order?: ModelOrderResponse;
  lastNotification?: ModelNote;
  cancellationFee: number;
  isSubmitting: boolean;
}>();

defineEmits<{ accept: []; dispute: []; reject: [] }>();

const merchantTermsDetail = computed(() => cleanDetails(props.lastNotification?.details));
</script>
